import $ from 'jquery';

export default function filterTree() {
  // Show child lists when parent node is clicked
  $('.js-filter-tree-parent-node').on('click', function () {
    const isChecked = $(this).is(':checked');

    if ( isChecked ) {
      const $children = $(this).closest('.js-filter-tree').find('.js-filter-tree-children');

      $(this).closest('.js-filter-tree').find('.js-filter-tree-toggle-btn').addClass('is-active');
      $children.not(':first').show();
      $children.first().slideDown();
    }
  });

  $('.js-filter-tree-node').on('change', function () {
    const isChecked = $(this).is(':checked');

    // If parent node is clicked
    if ( $(this).hasClass('js-filter-tree-parent-node') ) {
      const $nodes = $(this).closest('.js-filter-tree').find('.js-filter-tree-node').not($(this));

      // Toggle child checkboxes when parent checkbox is clicked
      $nodes.prop('checked', isChecked).trigger('change');
    }

    // If child node is clicked
    if ( $(this).hasClass('js-filter-tree-child-node') ) {
      const $wrappers = $(this).parents('.js-filter-tree');

      // Toggle parent checkbox when all child checkboxes are checked/unchecked
      $wrappers.each(function () {
        const $nodes = $(this).find('.js-filter-tree-children > .js-filter-tree-node-wrap .js-filter-tree-child-node');
        const $checkedNodes = $nodes.filter(':checked');
        const isAllChecked = $nodes.length === $checkedNodes.length;

        $(this).find('> .js-filter-tree-row .js-filter-tree-parent-node').prop('checked', isAllChecked).trigger('customChange');
      });
    }
  });

  // Toggle child list
  $('.js-filter-tree-toggle-btn').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).closest('.js-filter-tree').find('.js-filter-tree-children').first().slideToggle();
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/filter-tree.js